var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsOptional, IsString, Matches, MaxLength, ValidateIf } from 'class-validator';
import { CALENDAR_DATE } from './calendar-date.js';
/**
 * Corrects a recorded Befreiung (#1496). Every field is optional; an explicit
 * `null` on `validTo` reopens the window. `null` on `validFrom` is refused — a
 * window without a start is not one.
 */
export class UpdateCopaymentExemptionDto {
    // `ValidateIf` rather than `IsOptional`, which would wave `null` through as
    // well and leave the handler's `dto.validFrom ?? exemption.validFrom` reading
    // it as "field not sent". A window has a start; only `validTo` is nullable.
    validFrom;
    validTo;
    note;
}
__decorate([
    ValidateIf((_, value) => value !== undefined),
    IsString(),
    Matches(CALENDAR_DATE, { message: 'validFrom muss im Format "YYYY-MM-DD" vorliegen' }),
    __metadata("design:type", String)
], UpdateCopaymentExemptionDto.prototype, "validFrom", void 0);
__decorate([
    ValidateIf((_, value) => value !== null && value !== undefined),
    IsString(),
    Matches(CALENDAR_DATE, { message: 'validTo muss im Format "YYYY-MM-DD" vorliegen' }),
    __metadata("design:type", Object)
], UpdateCopaymentExemptionDto.prototype, "validTo", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(255),
    __metadata("design:type", Object)
], UpdateCopaymentExemptionDto.prototype, "note", void 0);
//# sourceMappingURL=update-copayment-exemption.dto.js.map